import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ReferenceDataContextualHelps } from '../../../lib/constants/reference-data-contextual-helps';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../../lib/constants/reference-data-option-lists';
import { SectionDto } from '../../../lib/models/dto';
import { Kfi } from '../models/kfi.model';
import { KfiStore } from '../services/kfi-store';

@Directive()
export abstract class BaseKfiPage implements OnDestroy, OnInit {
  public kfi: Kfi;
  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataContextualHelps = ReferenceDataContextualHelps;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public sections: { [key: string]: SectionDto };
  public hasSubmitValidationError?: boolean;

  protected destroySubject$ = new Subject();

  constructor(protected kfiStore: KfiStore) {}

  public ngOnInit(): void {
    this.kfiStore.dataObservable.pipe(takeUntil(this.destroySubject$)).subscribe((data) => {
      this.kfi = data.Entity;
      this.sections = data.Sections;
      this.hasSubmitValidationError =
        data.hasSubmitValidationError !== undefined ? data.hasSubmitValidationError : this.hasSubmitValidationError;
    });
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
